<script lang="ts">
  import AboutAuthor from "../common/AboutAuthor.svelte";
</script>

<div>
  <AboutAuthor />
</div>

<style>
</style>
